import { IResolvers as ICoreResolvers, IClientService } from '@workbench-stack/core';
import { StaticServices } from '@vscode-alt/monaco-editor/esm/vs/editor/standalone/browser/standaloneServices';

const dialogResolvers: (services: () => IClientService) => ICoreResolvers = (services) => {
    return ({
        Query: {
            showDialog: (_, args, context) => {
                console.log('SHOW DIALOG RESOLVER----', args, services());
                return StaticServices.dialogService.get().confirm(args.dialog as any);
            },
        },
        Mutation: {
            show: (_, args, context) => {
                return services().dialogService.show(args.dialog);
            },
            closeDialog: (_, args, context) => {
                return services().dialogService.closeDialog();
            },
        },
    });
};

export { dialogResolvers };
